// @ts-nocheck
import { WorkingHoursType } from '../../../models/WorkingHours';
import { API_PATHS } from './apis';
import api from '../../../../../../services/api';

export interface WorkingHoursResponse {
  WorkingHours: WorkingHoursType[];
  TimeZoneId: string;
}

export const fetchWorkingHours = async (
  userId: string,
  setWorkingHours: (workingHours: WorkingHoursType[]) => void,
  setTimezone: (timezone: string) => void,
  setLoading: (loading: boolean) => void
) => {
  setLoading(true);
  try {
    const url = `${API_PATHS.getWorkingHours}${userId}`;

    const response = await api.get<WorkingHoursResponse>(url);
    const { WorkingHours, TimeZoneId } = response.data;

    updateSettings(WorkingHours, TimeZoneId, setWorkingHours, setTimezone);
  } catch (error) {
    console.error('Error fetching working hours:', error);
  } finally {
    setLoading(false);
  }
};

export const updateWorkingHours = async (
  userId: string,
  workingHours: WorkingHoursType[],
  timezone: string,
  setWorkingHours: (workingHours: WorkingHoursType[]) => void,
  setTimezone: (timezone: string) => void
) => {
  try {
    const requestData = {
      WorkingHours: workingHours,
      Timezone: timezone,
    };

    const url = `${API_PATHS.updateWorkingHours}${userId}`;

    const response = await api.put<WorkingHoursResponse>(url, requestData);

    const { WorkingHours, TimeZoneId } = response.data;

    updateSettings(WorkingHours, TimeZoneId, setWorkingHours, setTimezone);
  } catch (error) {
    console.error('Error updating working hours:', error);
  }
};

const updateSettings = (
  workingHours: WorkingHoursType[],
  timeZoneId: string | undefined,
  setWorkingHours: (workingHours: WorkingHoursType[]) => void,
  setTimezone: (timezone: string) => void
) => {
  if (workingHours.length > 1) {
    setWorkingHours(workingHours);
  }

  if (timeZoneId) {
    setTimezone(timeZoneId);
  }
};
